import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;

  .label {
    font-weight: 600;
  }

  .hint {
    color: var(--neutral_medium);
    font-size: 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: baseline;

  .code {
    font-size: 16px;
    font-weight: 600;
  }

  .vessel {
    display: flex;
    color: var(--neutral_medium);
  }
`;
